import {
    IBREPORTS_CONTRACT_DETAILS_FETCH,
    IBREPORTS_REBATE_EARNINGS_FETCH,
    IBREPORTS_SUMMARY_FETCH,
    IBREPORTS_TRADING_ACCOUNTS_FETCH,
    IBREPORTS_ACCOUNT_STATEMENT_FETCH,
    IBREPORTS_IS_FETCHING,
    IBREPORTS_API,
  } from 'constants/ibReports'
  
  //HTTP reuests actions
  import {
    get,
    getContent
  } from 'actions/requests'
  
  export const ibReportSummaryFetch = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return get(`${IBREPORTS_API}/summary`, params)
        .then((e) => {
            dispatch(ibReportsSummaryFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  
  export const ibReportSummaryCsv = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return getContent(`${IBREPORTS_API}/summary-csv`, params)
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }
  
  export const ibReportContractDetailsFetch = (params) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))

    return get(`${IBREPORTS_API}/contract-details`, params)
        .then((e) => {
            dispatch(ibReportsContractDetailsFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }
  
  export const adminReportContractDetailsFetch = (params) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))

    return get(`adminreports/contract-details`, params)
        .then((e) => {
            dispatch(ibReportsContractDetailsFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  export const ibRebateEarningsFetch = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return get(`${IBREPORTS_API}/trades-rebates`, params)
        .then((e) => {
            dispatch(ibRebateEarningsFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  export const ibRebateEarningsCsv = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return getContent(`${IBREPORTS_API}/trades-rebates-csv`, params)
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }
  
  export const tradingAccountsFetch = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return get(`${IBREPORTS_API}/accounts-total-rebates`, params)
        .then((e) => {
            dispatch(tradingAccountsFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  export const tradingAccountsCsv = ({from, to, includeChildren, profileId}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren
    }
    if(profileId) {
      params.profileId = profileId
    }
    return getContent(`${IBREPORTS_API}/accounts-total-rebates-csv`, params)
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }
  
  export const accountStatementFetch = ({from, to, includeChildren, paymentTypes}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren,
      paymentTypes
    }

    if(paymentTypes==="All") {
      params.paymentTypes = ['Rebates', 'Withdrawal', 'Adjustment'];
    }
    
    return get(`${IBREPORTS_API}/account-statement`, params)
        .then((e) => {
            dispatch(accountStatementFetched(e))
            return e
        })
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  export const accountStatementCsv = ({from, to, includeChildren, paymentTypes}) => (dispatch) => {
    dispatch(ibReportsIsFetching(true))
    let params = {
      from,
      to,
      includeChildren,
      paymentTypes
    }
    return getContent(`${IBREPORTS_API}/account-statement-csv`, params)
        .then((e) => {
            return e
        })
        .then((e) => { dispatch(ibReportsIsFetching(false)); return e; })
  }

  export const ibReportsSummaryFetched = (payload) => ({ type: IBREPORTS_SUMMARY_FETCH, payload: payload })
  export const ibReportsIsFetching = (payload) => ({ type: IBREPORTS_IS_FETCHING, payload: payload })
  export const ibReportsContractDetailsFetched = (payload) => ({ type: IBREPORTS_CONTRACT_DETAILS_FETCH, payload: payload })
  export const tradingAccountsFetched = (payload) => ({ type: IBREPORTS_TRADING_ACCOUNTS_FETCH, payload: payload })
  export const accountStatementFetched = (payload) => ({ type: IBREPORTS_ACCOUNT_STATEMENT_FETCH, payload: payload })
  export const ibRebateEarningsFetched = (payload) => ({ type: IBREPORTS_REBATE_EARNINGS_FETCH, payload: payload })



// WEBPACK FOOTER //
// ./src/actions/ibReports.js